import React, { useState } from 'react';
import { FaCircleUser } from 'react-icons/fa6';
import { MdContactMail } from 'react-icons/md';
import { AiOutlineProfile } from 'react-icons/ai';
import { GrServices } from 'react-icons/gr';
import { FaProjectDiagram } from 'react-icons/fa';
import { FaBlogger } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";

import './header.css';

const Header = () => {
  const [activeNav, setActiveNav] = useState('#about');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleClick = (section) => {
    setActiveNav(section);
    setMenuOpen(false);
  };

  const handleToggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="main-header">
      <a href="/" className="logo">CodingwithSSR</a>

      {/* Hamburger Icon */}
      <div className="menu-toggle" onClick={handleToggle}>
        {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
      </div>

      {/* Navigation Menu */}
      <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <a href="/#about" onClick={() => handleClick('#about')} className={activeNav === '#about' ? 'active' : ''}>
          <FaCircleUser /> About
        </a>
        <a href="/#experience" onClick={() => handleClick('#experience')} className={activeNav === '#experience' ? 'active' : ''}>
          <AiOutlineProfile /> Experience
        </a>
        <a href="/#services" onClick={() => handleClick('#services')} className={activeNav === '#services' ? 'active' : ''}>
          <GrServices /> Services
        </a>
        <a href="/#project" onClick={() => handleClick('#project')} className={activeNav === '#project' ? 'active' : ''}>
          <FaProjectDiagram /> Project
        </a>
        <a href="/#contact" onClick={() => handleClick('#contact')} className={activeNav === '#contact' ? 'active' : ''}>
          <MdContactMail /> Contact
        </a>
        <a href="/blog" onClick={() => handleClick('blog')} className={activeNav === 'blog' ? 'active' : ''}>
          <FaBlogger /> Blog
        </a>
      </div>
    </header>
  );
};

export default Header;






